type ProductConfiguration = {
  variantKey?: string
  configurationKey?: string | null
  dimensioningKey?: string | null
}

export function isConfigurationEqual(
  a: ProductConfiguration,
  b: ProductConfiguration
): boolean {
  return (
    a.variantKey === b.variantKey &&
    a.configurationKey === b.configurationKey &&
    a.dimensioningKey === b.dimensioningKey
  )
}
